import { type UseQueryResult, useQuery } from 'react-query';
import { MyHoldingsService } from '../../services/wealthlane-award-services';

const useGetOptionAwardNumber = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tabValue: string
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const optionAwardNumber = useQuery(
    ['getOptionAwardNumber', tabValue],
    async () => {
      return await handleRequest(
        MyHoldingsService.getApiAwardApiAppMyHoldingsOptionAwardNumbers(tabValue)
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.awardNumber ?? '',
            value: item.optionAwardId ?? '',
          };
        });
      },
    }
  );

  return optionAwardNumber;
};

export default useGetOptionAwardNumber;
